import { constants } from '../../../../common/Localization';
import { ResourceType, ResourceTypesMap, SHOW_MAPPED_STATUS, WizardStep, WizardStepsMap } from './types';

/**
 * An object that specifies label and value for a resource type
 */
export const RESOURCE_TYPES = [
    {
        hasOptionalHeaders: true,
        label: constants.RESOURCE_TYPE_LABELS.SERVER,
        url: '/assets/servers',
        value: 'server',
    },
    {
        label: constants.RESOURCE_TYPE_LABELS.APPLICATION,
        url: '/assets/applications',
        value: 'application',
    },
    {
        label: constants.RESOURCE_TYPE_LABELS.SERVER_TO_APPLICATION,
        url: '/dependencies/application-servers',
        value: 'applicationServer',
    },
    {
        allowDuplicates: true,
        label: constants.RESOURCE_TYPE_LABELS.SERVER_COMMUNICATION,
        url: '/dependencies/server-communications',
        value: 'serverCommunication',
    },
    {
        label: constants.RESOURCE_TYPE_LABELS.DATABASE,
        url: '/assets/databases',
        value: 'database',
    },
    {
        label: constants.RESOURCE_TYPE_LABELS.DATABASE_TO_APPLICATION,
        url: '/dependencies/database-applications',
        value: 'databaseApplication',
    },
    {
        allowDuplicates: true,
        label: constants.RESOURCE_TYPE_LABELS.APPLICATION_DEPENDENCY,
        url: '/dependencies/application-dependencies',
        value: 'applicationDependency',
    },
];

/**
 * A map from ResourceType.value to the ResourceType object
 */
export const RESOURCE_TYPES_MAP = RESOURCE_TYPES.reduce((map: ResourceTypesMap, type: ResourceType) => {
    map[type.value] = type;
    return map;
}, {} as ResourceTypesMap);

/**
 * An enum that defines stages in import process
 */
export enum STAGE_VALUES {
    DEFAULT = 'default',
    WIZARD = 'wizard',
}

/**
 * An enum that defines steps in import wizard
 */
export enum WIZARD_STEP_VALUES {
    SELECT_SHEET = 'selectSheet',
    HEADER_MAPPING = 'headerMapping',
    DUPLICATE_RECORDS = 'duplicateRecords',
    PREVIEW = 'preview',
}

const WIZARD_STEPS: WizardStep[] = [
    {
        label: constants.WIZARD_STEP_LABELS.SELECT_SHEET,
        value: WIZARD_STEP_VALUES.SELECT_SHEET,
    },
    {
        label: constants.WIZARD_STEP_LABELS.HEADER_MAPPING,
        value: WIZARD_STEP_VALUES.HEADER_MAPPING,
    },
    {
        label: constants.WIZARD_STEP_LABELS.DUPLICATE_RECORDS,
        value: WIZARD_STEP_VALUES.DUPLICATE_RECORDS,
    },
    {
        label: constants.WIZARD_STEP_LABELS.PREVIEW,
        value: WIZARD_STEP_VALUES.PREVIEW,
    },
];

/**
 * A map from WizardStep.value to the WizardStep object
 */
export const WIZARD_STEPS_MAP: WizardStepsMap = WIZARD_STEPS.reduce((map: WizardStepsMap, step: WizardStep): WizardStepsMap => {
    map[step.value] = {
        ...step,
        onNext: async () => {},
        onPrev: async () => {},
    };
    return map;
}, {});

/**
 * An enum that defines options to quickly select records for all duplicated IDs
 */
export enum DUPLICATE_SELECT_OPTION {
    FIRST = 'first',
    LAST = 'last',
    MANUAL = 'manual',
}

/**
 * Pagination config for polaris Cards and Tables
 */
export const PAGE_SIZE = 10;

export const OVERWRITE_COMPARISON_LIMIT = 10;

/**
 * File <input> accept types for excel/csv
 */
export const INPUT_DATA_FILE_TYPES = [
    'text/csv',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel',
];

export const IMPORT_FILE_SIZE_LIMIT_IN_MB = 20;

export const SHOW_MAPPED_OPTIONS = [
    {
        value: SHOW_MAPPED_STATUS.ALL,
        label: constants.SHOW_MAPPED_LABELS.ALL,
    },
    {
        value: SHOW_MAPPED_STATUS.MAPPED,
        label: constants.SHOW_MAPPED_LABELS.MAPPED,
    },
    {
        value: SHOW_MAPPED_STATUS.UNMAPPED,
        label: constants.SHOW_MAPPED_LABELS.UNMAPPED,
    },
];

// Reference: http://en.wikipedia.org/wiki/List_of_file_signatures
export const EXCEL_MAGIC_NUMBERS: string[] = [
    '504b34', // xlsx
    'd0cf11e0', // xls
];
